import toast from "react-hot-toast";
import axios from "axios";
const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const viewBuilderList = (builderData) => {
  return async (dispatch) => {
    // dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "GET_BUILDERS_LIST_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.post(
        `${BASE_URL}/builder/list`,
        builderData,
        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "GET_BUILDERS_LIST_SUCCESS", payload: data });
      } else {
        dispatch({ type: "GET_BUILDERS_LIST_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "GET_BUILDERS_LIST_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const viewBuilder = (builderData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "GET_BUILDER_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.get(
        `${BASE_URL}/builder/profile/${builderData}`,
        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "GET_BUILDER_SUCCESS", payload: data });
      } else {
        dispatch({ type: "GET_BUILDER_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "GET_BUILDER_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const addNewBuilder = (builderData) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "ADD_NEW_BUILDER_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.post(
        `${BASE_URL}/builder/add`,
        builderData,
        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "ADD_NEW_BUILDER_SUCCESS", payload: data });
        toast.success("Added Successfully!");
      } else {
        dispatch({ type: "ADD_NEW_BUILDER_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "ADD_NEW_BUILDER_FAILED",
        payload: error?.response?.data?.message,
      });
    }
  };
};

export const changeBuilderStatus = (builderData) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "CHANGE_BUILDER_STATUS_REQUEST" });

      const config = {
        headers: {
          "Content-type": "application/json",
        },
      };
      const { data } = await axios.post(
        `${BASE_URL}/builder/change-status`,
        builderData,
        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "CHANGE_BUILDER_STATUS_SUCCESS", payload: data });
        toast.success("Changed Successfully!!");
        return data;
      } else {
        dispatch({ type: "CHANGE_BUILDER_STATUS_FAILED", payload: data });
        return data;
      }
    } catch (error) {
      dispatch({
        type: "CHANGE_BUILDER_STATUS_FAILED",
        payload: error?.response?.data?.message,
      });
      return error?.response?.data;
    }
  };
};
